/**
 * RNAPI 2
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RnRNOrderHeader } from "../models/./rNOrderHeader-d";
import { RnEventLogInfo } from "../models/./eventLogInfo-d";
import { RnRNSubOrganization } from "../models/./rNSubOrganization-d";

export class RnSubOrganizationCreate {
  Header: RnRNOrderHeader;
  SubOrganization: RnRNSubOrganization;
  EventLogInfo?: RnEventLogInfo;
  AffectedOrganizationId?: number;
  AffectedUserId?: number;
}
